import React from "react";
import "./styles.scss";

interface IProps {
  status: "Completed" | "Inprogress";
  title: string;
  onClick(): void;
  disabled?: boolean;
}

const SubSectionCard = (props: IProps) => {
  return (
    <div
      className={
        props.disabled
          ? "student-subsection-cardx"
          : "student-subsection-cardx card-enabled"
      }
      onClick={props.onClick}
    >
      <div className="title">
        <h3 style={{ fontWeight: 700, color: "#6b6969" }}>{props.title}</h3>
      </div>
      <div className="status">
        <StatusLabel status={props.status} />
      </div>
    </div>
  );
};

interface IPropsStatusLable {
  status: "Completed" | "Inprogress";
}

const StatusLabel = (props: IPropsStatusLable) => {
  if (props.status === "Completed") {
    return <div className="st-status-label completed">Completed</div>;
  } else {
    return <div className="st-status-label inprogress">In progress</div>;
  }
};

export default SubSectionCard;
